<!--
 * @Author: xiehangyi
 * @LastEditors: Please set LastEditors
 * @Description: file 上传文件
-->

<template>
  <div class="lc-file">
    <el-upload
      v-if="showEnter"
      class="lc-upload"
      v-bind="$props"
      :on-preview="handlePreview"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :file-list="fileList"
      :auto-upload="false"
      :show-file-list="false"
    >
      <slot></slot>
      <template v-if="drag">
        <!-- <i class="el-icon-upload"></i> -->
        <!-- <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
        <div class="lc-upload__add">
          <i class="el-icon-upload2" :class="limit == fileList.length ? 'is-disabled' : ''" />
          <span>添加文件</span>
          <span class="lc-upload__add-limit" v-if="limit"> {{ fileList.length }}/{{ limit }}</span>
        </div>
        <div class="lc-upload__desc" v-if="maxsize">
          单个文件不超过<span>{{ maxsize }}</span>
        </div>
      </template>
      <!-- <div v-if="uploadTip" slot="tip" class="el-upload__tip">
        {{ uploadTip }}
      </div> -->
    </el-upload>

    <div v-if="showFileList && showType === 'list'" class="lc-list">
      <template v-for="(item, index) in fileList" :key="item.key || index">
        <div class="lc-list__item" >
          <svg-icon :icon-class="getFileIcon(item.fileType)" class-name="lc-list__item-icon" />
          <span class="lc-list__item-label" :title="item.name">{{ item.name }}</span>
          <span class="lc-list__item-operates lc-file-button">
            <el-button type="text" @click="handleFileDeleteItem(item)">删除</el-button>
            <el-button type="text" @click="handleFileDownLoad(item)">下载</el-button>
          </span>
        </div>
      </template>
    </div>
    <!-- table展示 -->
    <el-table v-if="showFileList && showType === 'table' && fileList.length" :data="fileList" class="lc-file-show-table">
      <el-table-column prop="name" label="文件名" min-width="150px" />
      <el-table-column prop="handle" label="操作" min-width="100px">
        <template #default="{row}">
          <el-button type="text" @click="handleFileDeleteItem(row)">删除</el-button>
          <el-button type="text" @click="handleFileDownLoad(row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { downloadFile } from '@/utils/common.js';
import { fileDownload } from '@/apis/application/file.js';
import { request } from '@/apis/request';
export default {
  name: 'LcFile',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    // 上传文件地址
    action: {
      type: String,
      default: 'https://jsonplaceholder.typicode.com/posts/'
    },
    // 上传url请求类型
    method: {
      type: String,
      default: 'POST'
    },
    // 设置上传的请求头部
    headers: {
      type: Object,
      default: () => ({})
    },
    // 上传时附带的额外参数
    data: {
      type: Object,
      default: () => ({})
    },
    // 是否支持多文件
    multiple: {
      type: Boolean,
      default: true
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: 1
    },
    // 接受上传的文件类型
    accept: {
      type: String,
      default: ''
    },
    // 文件最大大小
    maxsize: {
      type: String,
      default: ''
    },
    // 是否展示文件列表
    showFileList: {
      type: Boolean,
      default: false
    },
    // 是否支持拖拽
    drag: {
      type: Boolean,
      default: false
    },
    // 上传回显形式 表格/列表
    showType: {
      type: String,
      default: 'list'
    },
    // 是否显示上传入口
    showEnter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  computed: {
    uploadTip() {
      if (this.accept && this.maxsize) {
        return `只能上传${this.accept}文件，且不超过${this.maxsize}`;
      } else if (this.accept) {
        return `只能上传${this.accept}文件`;
      } else if (this.maxsize) {
        return `文件大小不超过${this.maxsize}`;
      } else {
        return false;
      }
    }
  },
  watch: {
    fileList(val) {
      this.$emit('input', val);
    }
  },
  created() {
    this.fileList = this.value || [];
  },
  methods: {
    handlePreview() {
      console.log('preview');
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleSuccess(response, file, fileList) {
      console.log('success');
    },
    handleError(err, file, fileList) {
      console.log('error');
    },
    handleChange(file, fileList) {
      const uid = file.uid;
      // 组装请求参数
      const formData = new FormData();
      formData.append('file', file.raw);
      for (const i in this.data) {
        formData.append(i, this.data[i]);
      }
      // 更新文件列表
      this.fileList = fileList.map(item => {
        const fileType = item.name.split('.').slice(-1)[0];
        return {
          uid: item.uid || '',
          name: item.name,
          fileType,
          fileCode: item.fileCode || ''
        };
      });
      // 发起请求
      request({
        url: this.action,
        method: this.method,
        headers: this.headers,
        data: formData
      })
        .then(res => {
          if (res[resDataName]) {
            const obj = this.fileList.find(e => e.uid === uid);
            obj && (obj.fileCode = res.data);
          } else {
            const index = this.fileList.findIndex(e => e.uid === uid);
            this.fileList.splice(index, 1);
          }
        })
        .catch(res => {
          const index = this.fileList.findIndex(e => e.uid === uid);
          this.fileList.splice(index, 1);
        });
    },
    handleRemove() {
      console.log('remove');
    },
    beforeRemove() {
      console.log('before-remove');
    },
    /**
     * 事件回调
     */
    handleFileDeleteItem(item) {
      this.fileList.splice(this.fileList.indexOf(item), 1);
    },
    handleFileDownLoad(item) {
      fileDownload({
        fileCode: item.fileCode,
        isOnline: false
      }).then(res => {
        downloadFile(res, item.name);
      });
    },
    getFileIcon(fileType) {
      switch (fileType) {
        case 'xls':
        case 'xlsx':
          return 'file-excel';
        case 'gif':
          return 'file-gif';
        case 'pdf':
          return 'file-pdf';
        case 'ppt':
          return 'file-ppt';
        case 'txt':
          return 'file-txt';
        case 'word':
          return 'file-word';
        case 'wps':
          return 'file-wps';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'bpm':
        case 'tif':
        case 'svg':
          return 'file-picture';
        case 'mp3':
        case 'wav':
        case 'wma':
          return 'file-audio';
        case 'mp4':
        case 'avi':
        case 'wmv':
        case 'mpg':
        case 'mpeg':
        case 'mov':
        case 'rm':
        case 'ram':
        case 'swf':
        case 'flv':
          return 'file-video';
        case 'zip':
        case 'rar':
        case '7z':
          return 'file-yasuobao';
        default:
          return 'file-default';
      }
    }
  }
};
</script>
<style lang="scss">
.lc-file{
  .lc-file-button, .lc-file-show-table{
    .el-button+.el-button{
      margin-left: 10px;
    }
  }
}
</style>
